module.exports = "import React from 'react';\n\nimport { SimpleTag as Tag } from '../../src';\n\nexport default () => <Tag text=\"Tag\" />;\n"